import { GENERIC_ANALYTICS_EVENTS } from './analyticsGenericEvents';

const CATEGORY = 'Finance settlement letter';

export const FSL_SNOW_PLOW_EVENTS = Object.freeze({
  ACCEPT_CONTINUE_CONSENT_MODAL_CLICK: () => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'Accept and continue',
    category: CATEGORY,
    label: 'fsl_accept_continue_button_clicked',
    name: 'fsl_accept_continue_selected',
    success: true,
    url: '',
  }),
  ALREADY_HAVE_FSL_LETTER_CLICK: () => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'I already have my finance letter',
    category: CATEGORY,
    label: 'fsl_already_have_fl',
    name: 'fsl_already_have_fl',
    success: true,
    url: '',
  }),
  BACK_TO_SUMMARY_BUTTON_CLICK: ({ url }: {url: string}) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'Back to summary',
    category: CATEGORY,
    label: 'fsl_back_to_summary_button_click',
    name: 'fsl_back_to_summary_selected',
    success: true,
    url,
  }),
  CLOSE_CONFIRM_DETAILS_MODAL_CLICK: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: CATEGORY,
    label: 'fsl_close_confirm_details_modal',
    name: 'fsl_close_confirm_details_modal',
    url: '',
  }),
  CLOSE_CONSENT_MODAL_CLICK: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: CATEGORY,
    label: 'fsl_close_modal',
    name: 'fsl_close_permission_modal',
    url: '',
  }),
  CONFIRM_DETAILS_CONTINUE_CLICK: () => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'Continue',
    category: CATEGORY,
    label: 'fsl_confirmed_details',
    name: 'fsl_confirm_details_continue_selected',
    success: true,
    url: '',
  }),
  CONNECT_TO_FINANCE_PROVIDER_CLICK: () => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'Connect to finance provider',
    category: CATEGORY,
    label: 'fsl_continue_button_click',
    name: 'fsl_connect_to_finance_provider_click',
    success: true,
    url: '',
  }),
  CONTINUE_BUTTON_CLICK: () => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'Continue',
    category: CATEGORY,
    label: 'fsl_continue_button_click',
    name: 'fsl_continue_selected',
    success: true,
    url: '',
  }),
  CONTINUE_POPUP_APPEAR: () => GENERIC_ANALYTICS_EVENTS.POPUP_LOAD_EVENT({
    category: CATEGORY,
    label: 'fsl_permission_modal',
    name: 'fsl_permission_modal_appear',
  }),
  CONTINUE_SUCCESS_CLICK: () => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'Continue',
    category: CATEGORY,
    label: 'fsl_continue_success',
    name: 'fsl_continue_clicked_success',
    success: true,
    url: '',
  }),
  DECLINE_CONSENT_MODAL_CLICK: () => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'Decline',
    category: CATEGORY,
    label: 'fsl_decline_consent',
    name: 'fsl_decline_consent_selected',
    success: true,
    url: '',
  }),
  DOWNLOAD_LETTER_CLICK: () => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'Download icon',
    category: CATEGORY,
    label: 'fsl_download_letter',
    name: 'fsl_download_letter',
    success: true,
    url: '',
  }),
  LOOKUP_FAILURE: () => GENERIC_ANALYTICS_EVENTS.POPUP_LOAD_EVENT({
    category: CATEGORY,
    label: 'fsl_lookup_failure',
    name: 'fsl_lookup_failure',
  }),
});
